import { Grid } from '@mui/material';
import React, { useState } from 'react';

import LoadingSpinner from '../../../../../components/Components/LoadingSpinner';
import TableX from '../../../../../components/Tables/TableX';
import ButtonComponent from '../../../../../components/Buttons/ButtonComponent';
import CustomizeButtonComponent from '../../../../../components/Buttons/CustomizeButtonComponent';
import { Icon, Paginate, PopUp, showToast } from '../../../../../components/ui';

const ModalListOR = (props) => {
    const [rowsCount, setRowsCount] = useState(50)
    const [numPage, setNumPage] = useState(1)
    const [filter, setFilter] = useState([])
    const [filterBy, setFilterBy] = useState([])
    const [stateX, setStateX] = useState({});
    const [sortArr, setSortArr] = useState([]);
    const [goTo, setGoTo] = useState(1);

    const selectData = () => {
        if (props.SelectedData.id === undefined) {
            showToast({ type: 'error', message: 'Please Select Data!' });
        }
        else {
            let check = 0;

            props.dataDetail.forEach(element => {
                if (element.invoiceId === props.SelectedData.invoiceId) {
                    check = 1;
                }
            });

            if (check === 0) {
                let Sequence = 1
                let id = 0
                if (props.Id) {
                    id = parseFloat(props.Id)
                }

                if (props.dataDetail.length > 0) {
                    Sequence = props.dataDetail.length + 1
                }

                let payload = {
                    "rowStatus": "ACT",
                    "sequence": Sequence,
                    "orpPh23Id": id,
                    "orId": props.SelectedData.orId,
                    "orNo": props.SelectedData.orNo,
                    "shipmentId": props.SelectedData.shipmentId,
                    "shipmentNo": props.SelectedData.shipmentNo,
                    "invoiceId": props.SelectedData.invoiceId,
                    "invoiceNo": props.SelectedData.invoicesNo,
                    "amountIDR": props.SelectedData.invoiceIDR,
                    "amountUSD": props.SelectedData.invoiceUSD,
                    "pph23Amount": props.SelectedData.pph23Amount,
                    "idLama": 0,
                }

                props.setDataDetail([...props.dataDetail, payload])
                props.SumTotal([...props.dataDetail, payload])
                handleReset();
                props.setSelectedDetail({})
                props.handleClick()
            }
            else {
                showToast({ type: 'error', message: 'Data Already Selected!' });
            }
        }
    }

    const handleReset = () => {
        setNumPage(1);
        setRowsCount(50);
        setFilter([]);
        setFilterBy([]);
        setGoTo(1);
        setSortArr([]);
        setStateX({});
        props.getData(1, 50)
    }

    function CellDoubleClick(row) {
        selectData()
    }

    const onChangePaging = (value) => {
        setNumPage(value);
        props.getData(value, rowsCount, filter);
    }

    const onChangeLimit = (value) => {
        setNumPage(1);
        setRowsCount(value);
        props.getData(1, value, filter);
    }

    const mainContainer = (
        <>
            <Grid item xs={12} style={{ width: "100%", borderRadius: "5px" }}>
                <div>
                    {
                        ButtonComponent.RefreshButton(
                            sortArr,
                            rowsCount,
                            props.columnData,
                            setGoTo,
                            handleReset,
                            setFilterBy,
                            filterBy,
                            setFilter,
                            setNumPage,
                            setRowsCount,
                            props.getData,
                            stateX,
                            setStateX
                        )
                    }
                </div>

                <div
                    className="rounded-10 table-responsive"
                    style={{
                        maxHeight: '375px',
                        marginTop: '16px',
                        padding: '2px 16px',
                        borderRadius: '12px',
                        background: '#F2F2F2'
                    }}
                >
                    {
                        props.isLoading ?
                            (
                                <LoadingSpinner />
                            )
                            :
                            (
                                <>
                                    <div className="mt-1">
                                        <TableX 
                                            uniqueKey={'id'}
                                            goTo={goTo}
                                            rowsCount={rowsCount}
                                            setNumPage={setNumPage}
                                            setRowsCount={setRowsCount}
                                            getData={props.getData}
                                            columnData={props.columnData}
                                            dataMap={props.dataMap}
                                            SelectedData={props.SelectedData}
                                            setSelectedData={props.setSelectedData}
                                            setFilter={setFilter}
                                            setFilterBy={setFilterBy}
                                            CellDoubleClick={CellDoubleClick}
                                            stateX={stateX}
                                            setStateX={setStateX}
                                            sortArr={sortArr}
                                            setSortArr={setSortArr}
                                            setGoTo={setGoTo}
                                        />
                                    </div>
                                </>
                            )
                    }
                </div>

                <div style={{ marginTop: '16px' }}>
                    <Paginate
                        page={numPage}
                        limit={rowsCount}
                        totalData={props.totalRows}
                        onChange={onChangePaging}
                        onChangeLimit={onChangeLimit}
                    />
                </div>
            </Grid>
        </>
    );

    return (
        <>
            <PopUp
                id='modal-id'
                icon={
                    <Icon
                        iconName={'approve-doc'}
                        svgIconProps={{
                            htmlColor: '#0087C2',
                            sx: {
                                height: '24px',
                                width: '24px'
                            }
                        }}
                    />
                }
                title={'Select Official Receipt'}
                isOpen={props.isModal}
                onClose={() => { handleReset(); props.handleClick(); }}
                draggable={false}
                shrinkable={false}
                disableScrollLock={false}
                maxWidth={'lg'}
                fullWidth={true}
            >
                <div style={{ padding: '0px 6px' }}>
                    {mainContainer}

                    <div style={{ padding: '24px 0px 0px' }}>
                        {CustomizeButtonComponent.SelectModalButton(selectData)}
                    </div>
                </div>
            </PopUp>
        </>
    )
}

export default ModalListOR